// extracted by mini-css-extract-plugin
module.exports = {"title":"FooterPayments_title__VUZAj","icons":"FooterPayments_icons__3TkWo","icon":"FooterPayments_icon__oBLs9"};